import { FC, PropsWithChildren } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const FilterNotifications: FC<PropsWithChildren> = ({ children }) => {
  return <div css={styles.container}>{children}</div>;
};

const styles = {
  container: css`
    order: 1;
    flex-basis: 100%;
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(1)};

    &:empty {
      display: none;
    }
  `,
};
